var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaerskLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 584 167",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.213 52.467v76.041h17.32V84.496l19.53 44.012H86.9l19.142-44.27v44.27h16.796V52.467h-19.4l-25.259 56.9-25.654-56.9H32.213zm131.77 0l-33.721 76.041h19.659l6.383-15.104h39.708l6.775 15.104h19.401l-33.984-76.041h-24.221zm66.017 0v76.041h72.787v-15.233H247.45V97.65h47.267V82.804H247.45V67.7h55.208V52.467H230zm86.85 0v76.041h17.837v-25.912h20.055l16.795 25.912h19.534l-17.709-26.562c.605 0 1.25.025 1.821 0 10.092 0 15.234-5.317 15.234-11.2V65.225c0-8.062-4.646-12.758-12.759-12.758H316.85zm100.262 0c-6.558 0-11.979 4.883-11.979 11.716v22.659c0 6.412 4.971 10.937 11.846 10.937h43.1v15.625H422.45v-5.862h-17.708v9.896c0 6.612 3.854 11.195 11.716 11.195h49.35c7.671 0 11.721-4.583 11.721-11.979V95.042c0-8.084-5.771-12.375-12.112-12.375H422.45V67.696h37.629v5.992h17.45V64.7c0-7.175-4.55-12.237-11.2-12.237h-49.221l.004.004zm77.342 0v76.171h18.1V94l35.025 34.638h25.263l-42.45-40.755 40.887-35.416h-24.35l-34.375 30.466V52.467h-18.1zM175.963 66.788l14.066 32.291h-27.737l13.675-32.291h-.005zm158.726.912h38.154v19.663h-38.154V67.7z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaerskLogoText);
export default __webpack_public_path__ + "static/media/Maersk_logo_text.f8c9f49cd85a0f628ec171a4cc46ac3a.svg";
export { ForwardRef as ReactComponent };